export default __webpack_public_path__ + "static/media/gallery_07.b3fd3a9f.jpg";